export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    showTable({commit}) {
        commit('showTable');
    },

    showForm({commit}) {
        commit('showForm');
    },
        closeForm({commit}) {
        commit('setFormClose');
    }

    // modifyEllatasVegeVisible({commit}, visible) {
    //     commit('modifyEllatasVegeVisible', visible);
    // },

    // modifyAmbulansEllatasTipus({commit}, visible) {
    //     commit('modifyAmbulansEllatasTipus', visible);
    // }
}